import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { HasPermission } from '../../../../containers/authorization-helpers/HasPermission';
import { PageNames } from '../../../../utils/app-constants';
import { AccountMateFinancials } from '../components/AccountMateFinancials';
import { CreditReport } from '../components/CreditReport';
import { DealerStatementReport } from '../components/DealerStatementReport';
import { OpenOrders } from '../components/OpenOrders';
import { PayrollComparisonReport } from '../components/PayrollComparisonReport';
import { ReleasedOrdersReport } from '../components/ReleasedOrdersReport';
import { MonthlyInvoiceReport } from '../components/MonthlyInvoiceReport';
import { TaxBreakdownReport } from '../components/TaxBreakdownReport';

export class AccountingReportsScene extends React.Component {

    public render() {        
        return <PageContent pageName={ PageNames.ACCOUNTING_REPORTS }>
            <PageBody>
                <div className="row">
                        <HasPermission requiredPermissions={[
                            Permissions.ReportsAccountingCredits
                        ]}>
                            <div className="col-md-4"><CreditReport /></div>
                        </HasPermission>
                    
                        <HasPermission requiredPermissions={[
                            Permissions.ReportsAccountingAccountmateFinancials
                        ]}>
                            <div className="col-md-4"><AccountMateFinancials /></div>
                        </HasPermission>

                        <HasPermission requiredPermissions={[
                            Permissions.ReportsAccountingOpenOrders
                        ]}>
                            <div className="col-md-4"><OpenOrders /></div>
                        </HasPermission>
                </div>
                <div className="row">
                        <HasPermission requiredPermissions={[
                            Permissions.ReportsAccountingReleasedOrders
                        ]}>
                            <div className="col-md-4"><ReleasedOrdersReport /></div>
                    </HasPermission>
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsAccountingDealerStatement
                    ]}>
                        <div className="col-md-4"><DealerStatementReport /></div>
                    </HasPermission>
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsAccountingPayrollComparison
                    ]}>
                        <div className="col-md-4"><PayrollComparisonReport /></div>
                    </HasPermission>
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsAccountingMonthlyInvoiceReport
                    ]}>
                        <div className="col-md-4"><MonthlyInvoiceReport /></div>
                    </HasPermission>
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsAccountingTaxBreakdownReport
                    ]}>
                        <div className="col-md-4"><TaxBreakdownReport /></div>
                    </HasPermission>
                </div>
            </PageBody>
        </PageContent>;
    }

}
